/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Agents_QuestionInputs */

const en_faq_agents_question = /** @type {(inputs: Faq_Agents_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do you build custom AI agents?`)
};

const lv_faq_agents_question = /** @type {(inputs: Faq_Agents_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai Jūs izstrādājat AI aģentus?`)
};

/**
* | output |
* | --- |
* | "Do you build custom AI agents?" |
*
* @param {Faq_Agents_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_agents_question = /** @type {((inputs?: Faq_Agents_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Agents_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_agents_question(inputs)
	return en_faq_agents_question(inputs)
});